'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');
var _components = require('../../components');


var _CompanyCellDesktop = require('./CompanyCellDesktop.scss');var styles = _interopRequireWildcard(_CompanyCellDesktop);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var CompanyCellDesktop = function CompanyCellDesktop(props) {var _cx, _cx2;
  var handleClick = function handleClick() {return _reactRouter.browserHistory.push(props.link);};

  return (
    _react2.default.createElement('div', { onClick: handleClick, className: styles.companyCell },
      _react2.default.createElement('div', { className: styles.logo, style: { backgroundImage: 'url(' + props.logo + ')' } }),
      _react2.default.createElement('div', { className: styles.about },
        _react2.default.createElement('h2', {
            className: (0, _classnames2.default)(styles.title, (_cx = {}, _cx[styles.defaultLang] = props.nameAtDefaultLang, _cx)) },

          props.name),

        _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.description, (_cx2 = {}, _cx2[styles.defaultLang] = props.descriptionAtDefaultLang, _cx2)) },
          _react2.default.createElement(_components.ShowMore, {
            text: props.description,
            moreButtonText: props.translate('propertyDetails', 'moreDescription'),
            hideButtonText: props.translate('propertyDetails', 'hideDescription'),
            heightLimit: 70,
            showHideButton: true }))),



      _react2.default.createElement('div', { className: styles.moreInfo },
        props.withoutCount ?
        _react2.default.createElement('div', { style: { height: '62px' } }) :

        _react2.default.createElement('div', { className: styles.countFlag },
          props.count > 0 && _react2.default.createElement('span', null, props.count),
          props.count > 0 && _react2.default.createElement('span', { className: styles.label }, props.translate('professionals', 'properties'))),


        _react2.default.createElement('button', null, props.translate('professionals', 'moreDetails')))));



}; // Styles

CompanyCellDesktop.propTypes = {
  translate: _propTypes2.default.func,
  name: _propTypes2.default.string,
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  logo: _propTypes2.default.string,
  link: _propTypes2.default.string,
  count: _propTypes2.default.number,
  nameAtDefaultLang: _propTypes2.default.bool,
  descriptionAtDefaultLang: _propTypes2.default.bool,
  clickHandler: _propTypes2.default.func,
  withoutCount: _propTypes2.default.bool };exports.default =


CompanyCellDesktop;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyCellDesktop/CompanyCellDesktop.js
// module id = 2632
// module chunks = 0